import { React } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';
import { ReactComponent as LeftArrowIcon } from '../../image/LeftArrow.svg';

const NoticePagination = (props) => {
  const {totalPage, nowPage, prevFn, nextFn} = props;
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <Button onClick={prevFn}>
        <StyledLeftArrow />
      </Button>
      <Page>{nowPage}/{totalPage}</Page>
      <Button onClick={nextFn}>
        <StyledRightArrow />
      </Button>
    </TopLevelWrapper>
  )
}

export default NoticePagination;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  height: 38px;

  gap: 30px;
  transition: all 0.3s ease-in-out;
`;

const Button = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.line};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      color: ${props => props.theme.text};
    }
  }
`;

const StyledLeftArrow = styled(LeftArrowIcon)`
  width: 9px;
  height: auto;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.line};
    transition: stroke 0.3s ease-in-out;
  }

  transition: all 0.3s ease-in-out;
`;

const StyledRightArrow = styled(LeftArrowIcon)`
  width: 9px;
  height: auto;

  flex-shrink: 0;

  transform: rotate(180deg);
  & path {
    fill: ${props => props.theme.line};
    transition: stroke 0.3s ease-in-out;
  }

  transition: all 0.3s ease-in-out;
`;

const Page = styled.p`
  position: relative;
  top: -2px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;